import { Pillar } from '@interfaces/pillar';
import ISection from './ISection';
import IBaseComponent from './Base/IBaseComponent';

export default class IProcessValue {
  readonly processId: string;
  readonly processVersion: number;
  readonly startAt: number;
  readonly sections: SectionValue[];
  readonly pillar: Pillar;
  readonly unit: string;

  constructor(
    processId: string,
    processVersion: number,
    pillar: Pillar,
    unit: string) {
    this.processId = processId;
    this.processVersion = processVersion;
    this.sections = [];
    this.pillar = pillar;
    this.unit = unit;
    this.startAt = Date.now();
  }
}

export class SectionValue {
  readonly sectionId: string;
  readonly id: string;
  readonly components: ComponentValue[];
  readonly fromGotoId?: string;
  readonly next?: string;
  readonly problem: boolean;
  readonly conditionId?: string;

  constructor(section: ISection) {
    this.sectionId = section.id;
    this.id = Date.now().toString();
    this.components = section.components.map(e => new ComponentValue(e));
    this.problem = false;
    this.fromGotoId = undefined;
    this.next = undefined;
    this.conditionId = undefined;
  }
}

export class ComponentValue {
  readonly id: string;
  readonly executedAt: number;
  readonly input: any;
  readonly problem?: boolean;
  readonly validation?: boolean;
  file: any;

  constructor(component: IBaseComponent) {
    this.id = component.id;
    this.executedAt = Date.now();
    this.input = undefined;
    this.problem = false;
    this.validation = undefined;
  }  
}